import React from 'react';

import PercentageInput from '../../PercentageInput';
import TextInput from '../../TextInput';
import Delete from '../../../Table/Row/Actions/Delete';
import Select from '../../Select';
import Explanation from './Explanation';

export default function Form({
  value,
  setFieldValue,
  id,
  name,
  values,
  errors,
  touched,
  setFieldTouched,
  setTouched,
  innerFields,
  readOnly,
}) {
  const onBlur = (inputName) => {
    setFieldTouched(`${name}[${id}].${inputName}`, true);
  };

  const touchedPart = touched?.[name]?.[id];

  const numberInputField = innerFields?.find(
    (field) => field.type === 'number'
  );
  const percentageInputField = innerFields.find(
    (field) => field.type === 'percentage'
  );
  const settingField = innerFields.find((field) => field.name === 'setting');
  const beforeAfterField = innerFields.find(
    (field) => field.name === 'before_after'
  );

  if (!numberInputField || !percentageInputField) {
    return null;
  }

  let isNumberFieldInputVisible = true;
  if (beforeAfterField && value?.[beforeAfterField?.name] === 'on') {
    isNumberFieldInputVisible = false;
  }

  return (
    <div>
      <div className="grid gap-5 md:grid-cols-5 xl:grid-cols-5 items-end">
        {settingField && (
          <Select
            label={settingField?.title}
            options={settingField?.options}
            value={value?.[settingField?.name]}
            // eslint-disable-next-line no-shadow
            setFieldValue={(_, value) => {
              setFieldValue(
                name,
                values[name].map((val, i) => {
                  if (i === id) {
                    return {
                      ...val,
                      [settingField?.name]: value,
                    };
                  }
                  return val;
                })
              );
            }}
            onBlur={() => onBlur(settingField?.name)}
            error={errors?.[settingField?.name]}
            touched={touchedPart?.[settingField?.name]}
            defaultValue={settingField?.defaultValue}
            readOnly={readOnly}
          />
        )}
        <PercentageInput
          error={errors?.[percentageInputField?.name]}
          touched={touchedPart?.[percentageInputField?.name]}
          onBlur={() => onBlur(percentageInputField?.name)}
          onChange={(e) => {
            // Replace empty string with null for optional required validation to work
            const newValue = e.target.value === '' ? null : e.target.value;

            setFieldValue(
              name,
              values[name].map((val, i) => {
                if (i === id) {
                  return {
                    ...val,
                    [percentageInputField?.name]: newValue,
                  };
                }
                return val;
              })
            );
          }}
          label={percentageInputField?.title}
          value={value?.[percentageInputField?.name]}
          limitDecimals={2}
          readOnly={readOnly}
        />
        {beforeAfterField && (
          <Select
            label={beforeAfterField?.title}
            options={beforeAfterField?.options}
            value={value?.[beforeAfterField?.name]}
            // eslint-disable-next-line no-shadow
            setFieldValue={(_, value) => {
              setFieldValue(
                name,
                values[name].map((val, i) => {
                  if (i === id) {
                    return {
                      ...val,
                      [beforeAfterField?.name]: value,
                    };
                  }
                  return val;
                })
              );
            }}
            onBlur={() => onBlur(beforeAfterField?.name)}
            error={errors?.[beforeAfterField?.name]}
            touched={touchedPart?.[settingField?.name]}
            defaultValue={beforeAfterField?.defaultValue}
            readOnly={readOnly}
          />
        )}
        {isNumberFieldInputVisible && (
          <TextInput
            readOnly={readOnly}
            min={numberInputField?.min}
            touched={touchedPart?.[numberInputField?.name]}
            error={errors?.[numberInputField?.name]}
            label={
              typeof numberInputField?.title === 'function'
                ? numberInputField?.title(values, id)
                : numberInputField?.title
            }
            value={value?.[numberInputField?.name]}
            type="number"
            onBlur={() => onBlur(numberInputField?.name)}
            onChange={(e) => {
              // Replace empty string with null for optional required validation to work
              const newValue = e.target.value === '' ? null : e.target.value;

              setFieldValue(
                name,
                values[name].map((val, i) => {
                  if (i === id) {
                    return {
                      ...val,
                      [numberInputField?.name]: newValue,
                    };
                  }
                  return val;
                })
              );
            }}
          />
        )}

        {id !== 0 && !readOnly && (
          <div className="md:pt-7">
            <Delete
              onClick={() => {
                setFieldValue(
                  name,
                  values[name].filter((val, i) => i !== id)
                );
                const newTouched = { ...touched };
                if (newTouched[name]) {
                  newTouched[name] = newTouched[name].filter(
                    (val, i) => i !== id
                  );
                }

                setTouched(newTouched);
              }}
            />
          </div>
        )}
      </div>
      <Explanation
        value={value}
        values={values}
        percentageInputField={percentageInputField}
        settingField={settingField}
        beforeAfterField={beforeAfterField}
        numberInputField={numberInputField}
      />
    </div>
  );
}
